var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGrowBusiness = function SvgGrowBusiness(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 14.4151V4.52829H26.1132L36 14.4151Z",
    fill: "#03CFAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7358 7.1698L20.6792 16.2264L17.1321 12.6038L0 29.7358V34.1887V36.9056L17.1321 19.7736L20.6792 23.3962L33.283 10.7924L29.7358 7.1698Z",
    fill: "#03CFAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6792 9.88679V0H10.7925L20.6792 9.88679Z",
    fill: "#007E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3208 1.81131L6.26415 10.7924L2.71698 7.1698L0 9.88678V17.1321L2.71698 14.4151L6.26415 18.0377L18.8679 5.43395L15.3208 1.81131Z",
    fill: "#007E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3774 35.0943V25.2076H22.4906L32.3774 35.0943Z",
    fill: "#0FF9D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.566 30.566L27.0189 27.0189L17.1321 36.9057H24.3019L30.566 30.566Z",
    fill: "#0FF9D4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrowBusiness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/growBusiness.47a24486.svg";
export { ForwardRef as ReactComponent };